import { Button } from './Button'

interface ErrorStateProps {
  title?: string
  message: string
  onRetry?: () => void
  technical?: string
}

function sanitizeMessage(message: string): string {
  const trimmed = message.trimStart()
  if (trimmed.startsWith('{')) {
    try {
      JSON.parse(trimmed)
      return 'An unexpected error occurred. Please retry.'
    } catch {
      // Not valid JSON — pass through as-is
    }
  }
  return message
}

export function ErrorState({ title = 'Error', message, onRetry, technical }: ErrorStateProps) {
  const displayMessage = sanitizeMessage(message)

  return (
    <div className="border border-swiss-gray-200 p-4">
      <p className="text-[13px] font-medium text-swiss-red mb-1">{title}</p>
      <p className="text-[13px] text-swiss-gray-700">{displayMessage}</p>
      {technical && (
        <details className="mt-3">
          <summary className="text-[11px] text-swiss-gray-500 cursor-pointer select-none">
            Technical details
          </summary>
          <pre className="mt-2 text-[11px] text-swiss-gray-500 font-swiss-mono whitespace-pre-wrap break-all">
            {technical}
          </pre>
        </details>
      )}
      {onRetry && (
        <div className="mt-4">
          <Button variant="secondary" onClick={onRetry}>
            Retry
          </Button>
        </div>
      )}
    </div>
  )
}
